export class StoryStep {
    static readonly media = 16;
    static readonly felling = 13;
    static readonly impact = 8;
    static readonly values = 14;
    static readonly text = 15;
    static readonly player = 5;
}